import React, { useCallback, useState } from 'react';
import css from './styles.module.scss';
import { Box, Grid, Switch, TextField, Typography } from '@material-ui/core';
import { Controller, useForm } from 'react-hook-form';
import { StepControls } from '~/common/step-controls';
import { useThunkDispatch } from '~/utils/hooks/useThunkDispatch';
import { INewMoneyStepOneFormInputs } from '~/models/money/new-money/formInputs';
import classNames from 'classnames';
import { TextInput } from '~/features/dashboard/components/add-deal/components/text-input';
import { newDealFormNextStep } from '~/features/dashboard/store/actions';
import MomentUtils from '@material-ui/pickers-next/adapter/moment';
import { DateRange, DateRangeDelimiter, DateRangePicker, LocalizationProvider } from '@material-ui/pickers-next';
import { useDateFormat } from '~/common/date-format';
interface Step_1Props {}

export const Step_1: React.FC<Step_1Props> = () => {
    // const match = useRouteMatch<{ creatorId: string }>();
    // const creatorId = useMemo(() => Number(match.params.creatorId), [match.params.creatorId]);
    // const newDealState = useSelector(selectNewDeal);
    const dispatch = useThunkDispatch();
    const { selectedDateFormat } = useDateFormat();
    const [periodCovers, setPeriodCovers] = React.useState<DateRange<Date>>([null, null]);
    const [amountPayable, setAmountPayable] = useState<boolean>(false);

    const { handleSubmit, register, control, setValue, errors } = useForm<INewMoneyStepOneFormInputs>({
        defaultValues: {
            isPayable: false,
            reference: '',
            usersRef: '',
            internalReference: '',
            isBilling: false,
        },
    });

    const onSubmit = useCallback(
        (data: INewMoneyStepOneFormInputs) => {
            // dispatch(createNewDealStepOneThunk({ ...data, creatorId, }));
            console.log('INewMoneyStepOneFormInputs', data);
            dispatch(newDealFormNextStep());
        },
        [dispatch]
    );

    return (
        <div className={css.module}>
            <form className={css.form} onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Typography align={'left'} variant={'h6'} className={classNames(css.bold, css.title)}>
                            test - test the Statement Received
                        </Typography>
                    </Grid>
                    <Grid item xs={4} style={{ display: 'flex', alignItems: 'center' }}>
                        <label className="customlabel bold">Does statement show amount payable?</label>
                    </Grid>
                    <Grid item xs={8}>
                        <div className={'inputcustom-outer switch-custom-outer'} style={{ display: 'flex', alignItems: 'center' }}>
                            <span>No</span>
                            <Controller
                                name="isPayable"
                                control={control}
                                render={props => {
                                    return (
                                        <Switch
                                            // size="small"
                                            id="e-book-switch1"
                                            type="checkbox"
                                            name="isPayable"
                                            onChange={e => setAmountPayable(e.target.checked)}
                                            // inputRef={register}
                                            value={amountPayable}
                                            checked={amountPayable}
                                        />
                                    );
                                }}
                            />
                            <span> Yes</span>
                        </div>
                    </Grid>
                    <Grid item xs={6} style={{ paddingLeft: '25px' }}>
                        <TextInput className={css.textInput} label={'User Ref'} name={'usersRef'} register={register} fieldError={errors.usersRef}/>
                    </Grid>
                    <Grid item xs={6} style={{ paddingRight: '25px' }}>
                        <TextInput
                            className={css.textInput}
                            label={'Internal Reference'}
                            name={'internalReference'}
                            register={register}
                            fieldError={errors.internalReference}
                        />
                    </Grid>
                    {amountPayable ? (
                        <>
                            <Grid item xs={12}>
                                <label className="customlabel bold">Enter payment details</label>
                            </Grid>
                            <Grid item xs={6} style={{ paddingLeft: '25px', paddingTop: '27px' }}>
                                <LocalizationProvider dateAdapter={MomentUtils}>
                                    <DateRangePicker
                                        startText="Select Date Form"
                                        endText="Select Date To"
                                        inputFormat={selectedDateFormat}
                                        value={periodCovers}
                                        onChange={newValue => setPeriodCovers(newValue)}
                                        renderInput={(startProps, endProps) => (
                                            <React.Fragment>
                                                <Box className={css.boxDate}>
                                                    <Typography className={css.fieldName}>{'Select Date From'}</Typography>
                                                    <TextField {...startProps} fullWidth label={''} className={css.textInput} variant="standard" />
                                                </Box>
                                                <DateRangeDelimiter className={css.dataRange}> - </DateRangeDelimiter>
                                                <Box className={css.boxDate}>
                                                    <Typography className={css.fieldName}>{'Select Date To'}</Typography>
                                                    <TextField {...endProps} fullWidth label={''} className={css.textInput} variant="standard" />
                                                </Box>
                                            </React.Fragment>
                                        )}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={6} style={{ paddingRight: '25px' }}>
                                <TextInput
                                    className={css.textInput}
                                    label={'Date Statement Received'}
                                    name={'usersRef'}
                                    register={register}
                                    fieldError={errors.usersRef}
                                />
                            </Grid>
                            <Grid item xs={12} style={{ paddingLeft: '25px' }}>
                                <label style={{ margin: '0' }} className="customlabel bold">Does the sender required an invoice to be send?</label>
                            </Grid>
                            <Grid item xs={12} style={{ paddingLeft: '25px' }}>
                                <div className={'inputcustom-outer switch-custom-outer'} style={{ display: 'flex', alignItems: 'center' }}>
                                    <label className="labelMoney">Self Billing?</label>
                                    <span>No</span>
                                    <Controller
                                        name="isBilling"
                                        control={control}
                                        render={props => {
                                            return (
                                                <Switch
                                                    id="e-book-switch1"
                                                    type="checkbox"
                                                    name="isBilling"
                                                    onChange={e => setValue('isBilling', e.target.checked)}
                                                    value={props.value}
                                                    checked={props.value}
                                                />
                                            );
                                        }}
                                    />
                                    <span> Yes</span>
                                </div>
                            </Grid>
                        </>
                    ) : (
                        ''
                    )}
                </Grid>
                <StepControls className={css.nextButton}/>
            </form>
        </div>
    );
};
